import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';

import { LoadingState } from '~libs/reduxUtils';

import { getAll, getOne, typePrefix } from '~lookups/actions/leaveRequests';

interface leaveRequestRow {
  id: number;
  date_start?: string;
  date_end?: string;
  reason?: { name?: string };
}

interface leaveRequestState {
  loading: LoadingState;
  error: string | null | undefined;
  rows: Array<leaveRequestRow>;
  row: leaveRequestRow;
}

const initialState: leaveRequestState = {
  loading: 'idle',
  error: null,
  rows: [],
  row: { id: -1 },
};

// Main slice, connecting API actions to redux state.
export const leaveRequestsSlice = createSlice({
  name: 'leave-requests',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAll.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      state.rows = action.payload.data;
    });
    builder.addCase(getOne.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      state.row = action.payload.data;
    });
    // Default matching for loading cases, pending when action is being called
    builder.addMatcher(isPending, (state, { type }) => {
      if (type.startsWith(`${typePrefix}/`)) state.loading = 'pending';
    });
    builder.addMatcher(isRejected, (state, action) => {
      if (action.type.startsWith(`${typePrefix}/`)) {
        state.loading = 'declined';
        state.error = action.error.message;
      }
    });
  },
});

export default leaveRequestsSlice.reducer;
